import initLanguageSwitcher from "./language";
import initUsefulLinks from './useful-links';
import initHeroPageParticles from './particles-hero';
import initLastDocsParticles from './particles-docs';
import animateOnScroll from './animate-on-scroll'
import initMobileMenu from './main-menu'

document.addEventListener("DOMContentLoaded", function () {
  initMobileMenu();
  initLanguageSwitcher();
  initUsefulLinks();
  initHeroPageParticles();
  initLastDocsParticles();
  animateOnScroll();
});
